import { useNavigate } from 'react-router-dom'
import TableFilter from './tableFilter'
import { useDispatch } from 'react-redux'
import { useState } from 'react'
import ExportButton from '../../common/ExportButton'
import { appAllGetEventBooking } from '../../store/eventbooking'
import { eventBookingExportColumns } from '../../config/exportColumns/eventBookingExportColumns'

function EventBooking() {
	const dispatch = useDispatch()

	const hubId = localStorage.getItem('hubId')
	const permissionOfHub = localStorage.getItem('permissionOfHub')

	const [exportFilters, setExportFilters] = useState({})

	return (
		<>
			<div className="content-wrapper">
				<div className="content-heading d-flex justify-content-between">
					<div>Event Booking</div>

					<ExportButton
						fetchAction={params =>
							dispatch(
								appAllGetEventBooking({
									...params,
									...exportFilters,
									hub: hubId || permissionOfHub,
									page: 1,
									limit: 10000,
									loading: false,
								}),
							)
						}
						columns={eventBookingExportColumns}
						fileName="Event_Booking"
						sheetName="Event Booking"
						buttonText="Export Event Booking"
					/>
				</div>

				<TableFilter setExportFilters={setExportFilters} />
			</div>
		</>
	)
}

export default EventBooking
